import { render, staticRenderFns } from "./BoxTitle.vue?vue&type=template&id=2f2e02c7&scoped=true&"
import script from "./BoxTitle.vue?vue&type=script&lang=js&"
export * from "./BoxTitle.vue?vue&type=script&lang=js&"
import style0 from "./BoxTitle.vue?vue&type=style&index=0&id=2f2e02c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e02c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
